import { normalizeToUTC } from "@revbox/helpers-fe";
import axiosInstance from "../../axios/instance";
import { getToken } from "../../helpers/get-token";
import { endOfDay, startOfDay, subDays } from "date-fns";

async function getPeriodRevenueByCluster(inventoryId, campaignId) {
    try {        
        const token = getToken();
        const currentPeriod = [
            startOfDay(subDays(new Date(), 30)), endOfDay(new Date())
        ];

        axiosInstance.defaults.headers.common['authorization'] = token;

        const response = await axiosInstance.post(process.env.REACT_APP_HUB_URL + '/api/analytics/revenue/period/cluster', {
            inventory_id: Number(inventoryId),
            campaign_id: Number(campaignId),
            current_period: [
                normalizeToUTC(currentPeriod[0]).getTime(),
                normalizeToUTC(currentPeriod[1]).getTime()
            ]
        })

        return response?.data;
    } catch (error) {
        console.log(error);
    }
}

export default getPeriodRevenueByCluster;
